import gql from 'graphql-tag';

export default fields => gql`
mutation ($budgetLine: UpdateBudgetLineInput!, $externalMaps: [UpdateExternalMapsInput]!) {
    updateBudgetLine (budgetLine: $budgetLine, externalMaps: $externalMaps) {
        __typename
        ${[...['id'].concat(fields)]}
    }
}`;


// WEBPACK FOOTER //
// ./src/GraphQueries/BudgetLines/UpdateMutation.js